import { Button } from '@xo-union/tk-component-buttons';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { messagingHubRoute } from '../../helpers/routes';
import useShareTracking from '../SharePage/useShareTracking';
import styles from './styles.scss';

const MessageGuestsButton = () => {
  const history = useHistory();
  const shareTrack = useShareTracking();

  const navigateToShare = () => {
    history.push(messagingHubRoute + '?source=/gs/dashboard');
    shareTrack('Website Share Initiated', { page: 'dashboard' });
  };

  return (
    <Button
      size="lg"
      color="secondary"
      onClick={navigateToShare}
      data-testid="message-guests"
      className={styles.primaryButton}
    >
      <span className={styles.desktopCopy}>Share your website</span>
      <span className={styles.mobileCopy}>Share</span>
    </Button>
  );
};

export default MessageGuestsButton;
